var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeleteMinor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 3.99388C8 2.89269 8.89543 2 10 2C11.1046 2 12 2.89269 12 3.99388H16C16.5523 3.99388 17 4.44023 17 4.99082C17 5.54142 16.5523 5.98776 16 5.98776H4C3.44772 5.98776 3 5.54142 3 4.99082C3 4.44023 3.44772 3.99388 4 3.99388H8Z",
    fill: "#E02D3C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 14.5076V8H7V14.5076C7 14.7829 7.22386 15.0061 7.5 15.0061H9V8H11L11 15.0061H12.5C12.7761 15.0061 13 14.7829 13 14.5076V8H15V14.5076C15 15.8841 13.8807 17 12.5 17H7.5C6.11929 17 5 15.8841 5 14.5076Z",
    fill: "#E02D3C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteMinor);
export default __webpack_public_path__ + "static/media/delete_minor.df1b3ea748bcd7cf950a41c2d27edb92.svg";
export { ForwardRef as ReactComponent };